export function productImgUrl(path: string): string {
  return `http://megaconecta.com/${path}`;
}
